module.exports = __webpack_public_path__ + "static/img/6.71b7296.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/6.png
// module id = XMAV
// module chunks = 0